import React from "react";
import { RemoveIcon } from "../removeIcon";
import { Props } from "./types";
import styles from "./styles.scss";

function Tag({ tag, remove }: Props) {
  return (
    <div
      key={tag.name}
      className={styles.tag}
      onClick={(e) => {
        e.stopPropagation();
        remove();
      }}
    >
      <p className={styles.name}>{typeof tag === "object" ? tag.name : tag}</p>
      <RemoveIcon className={styles.removeIcon} />
    </div>
  );
}

export { Tag };
